import { Row, Col, Form, Button, Image } from "react-bootstrap";
import { useState } from "react";
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';

const ImageField = ({ index, product, setProduct, searchForImage }) => {
  const { instance } = useMsal();
  const [showPreview, setShowPreview] = useState(!!product[`image${index}`]);
  const [searching, setSearching] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDeleteImage = () => {
    if (!product.productId) {
      // For new products that haven't been saved yet, just clear the image field
      setProduct({
        ...product,
        [`image${index}`]: null,
        [`imageSource${index}`]: null,
        [`imageName${index}`]: ''
      });
      setShowPreview(false);
      return;
    }
    
    // For existing products, call the API to delete the image
    setDeleting(true);
    
    authFetch(instance, `/api/delete_product_image/${product.productId}/${index}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        promoDatabaseId: product.promoDatabaseId
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // Clear the image field in the local state
        setProduct({
          ...product,
          [`image${index}`]: null,
          [`imageSource${index}`]: null,
          [`imageName${index}`]: ''
        });
        setShowPreview(false);
      } else {
        alert(`Error deleting image: ${data.error || 'Unknown error'}`);
      }
    })
    .catch(error => {
      console.error('Error deleting image:', error);
      alert('Failed to delete image');
    })
    .finally(() => {
      setDeleting(false);
    });
  };
  
  const handleImageSearch = (searchMfr) => {
    if (!product[`imageName${index}`]) return;
    
    setSearching(true);
    let key = product[`imageName${index}`];
    
    if (searchMfr) {
      // Fetch backend route to convert MFR to SKU
      authFetch(instance, '/api/mfr_image_search', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({'mfr': key}),
      })
      .then(response => response.json())
      .then(data => {
        if (data && data.sku) {
          return data.sku;
        } else {
          alert('Failed to convert MFR#' + key + ' to SKU.');
          throw new Error('MFR conversion failed');
        }
      })
      .then(sku => {
        // Use Flask backend proxy endpoint with fetch
        return authFetch(instance, `/api/proxy_image?key=${encodeURIComponent(sku)}`);
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setProduct({
            ...product, 
            [`image${index}`]: data.image_data,
            [`imageSource${index}`]: 'erp'
          });
          setShowPreview(true);
        } else {
          alert(`No image found for ${key}`);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        if (error.message !== 'MFR conversion failed') {
          alert('Failed to fetch image');
        }
      })
      .finally(() => {
        setSearching(false);
      });
    } else {
      // Direct SKU search
      authFetch(instance, `/api/proxy_image?key=${encodeURIComponent(key)}`)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setProduct({
            ...product, 
            [`image${index}`]: data.image_data,
            [`imageSource${index}`]: 'erp'
          });
          setShowPreview(true);
        } else {
          alert(`No image found for ${key}`);
        }
      })
      .catch(error => {
        console.error('Error fetching image:', error);
        alert('Failed to fetch image');
      })
      .finally(() => {
        setSearching(false);
      });
    }
  };
  

  
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setProduct({
          ...product, 
          [`image${index}`]: e.target.result,
          [`imageSource${index}`]: 'local'
        });
        setShowPreview(true);
      };
      reader.readAsDataURL(file);
    }
  };
  
  return (
    <Row className="mb-3 align-items-center">
      <Col xs={5}>
        <Form.Group>
          <Form.Label>Image {index}</Form.Label>
          <Form.Control 
            type="text"
            name={`imageName${index}`}
            value={product[`imageName${index}`] || ''}
            onChange={(e) => setProduct({...product, [`imageName${index}`]: e.target.value})}
            placeholder="Enter SKU or MFR to search"
          />
        </Form.Group>
      </Col>
      <Col xs={7} className="d-flex align-items-end">
        <Button 
          onClick={() => handleImageSearch(true)}
          className="me-2"
          variant="outline-primary"
          size="sm"
          disabled={searching || !product[`imageName${index}`]}
        >
          {searching ? 'Searching...' : 'Search by MFR'}
        </Button>
        <Button 
          onClick={() => handleImageSearch(false)}
          className="me-2"
          variant="outline-primary"
          size="sm"
          disabled={searching || !product[`imageName${index}`]}
        >
          {searching ? 'Searching...' : 'Search by SKU'}
        </Button>
        <Form.Control
          type="file"
          accept="image/*"
          onChange={handleFileUpload}
          style={{ width: '120px' }}
          size="sm"
        />
      </Col>
      {showPreview && product[`image${index}`] && (
        <Col xs={12} className="mt-2 d-flex align-items-center">
          <Image 
            src={product[`image${index}`]} 
            alt={`Product image ${index}`} 
            thumbnail 
            style={{ maxHeight: '100px' }} 
          />
          <div className="ms-3">
            <div className="small text-muted mb-1">
              {product[`imageSource${index}`] === 'local' ? 'Local upload' : 'From web'}
            </div>
            <Button
              variant="danger"
              size="sm"
              onClick={handleDeleteImage}
              disabled={deleting}
            >
              {deleting ? 'Deleting...' : 'Delete Image'}
            </Button>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default ImageField;